import { EyeIcon } from "@heroicons/react/24/outline";
import { Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Card, CardHeader, CardBody, TableRow, TableCell } from "@nextui-org/react";
import ClientTablePagination from "../../../../elements/ClientTablePagination";
import { groupDataByPerusahaanAsalMuatId } from "../../../../../services/helpers";

export default function ModalDetailPengangkutan({ data }) {
  const { isOpen, onOpen, onOpenChange } = useDisclosure();
  const groupedData = groupDataByPerusahaanAsalMuatId(data);

  const headerTujuanBongkar = [
    "Nama Perusahaan",
    "Alamat",
    // 'Provinsi',
    // 'Kabupaten',
    // 'Kecamatan',
    // 'Kelurahan',
    "Tipe Lokasi",
    "Koordinat",
    "Jumlah Angkut",
    "Jumlah Bongkar",
  ];

  const contentTujuanBongkar = (item) => (
    <TableRow key={item?.id}>
      <TableCell>{item?.namaPerusahaan}</TableCell>
      <TableCell>{item?.alamat}</TableCell>
      {/* <TableCell>{item?.perusahaanTujuanBongkar?.province?.name}</TableCell>
            <TableCell>{item?.perusahaanTujuanBongkar?.regency?.name}</TableCell>
            <TableCell>{item?.perusahaanTujuanBongkar?.district?.name}</TableCell>
            <TableCell>{item?.perusahaanTujuanBongkar?.village?.name}</TableCell> */}
      <TableCell>{item?.locationTypeTujuan}</TableCell>
      <TableCell>{`${item?.longitudeTujuan}, ${item?.latitudeTujuan}`}</TableCell>
      <TableCell>{item?.jumlahDiAngkut} Kg</TableCell>
      <TableCell>{item?.jumlahDiBongkar} Kg</TableCell>
    </TableRow>
  );

  return (
    <>
      <Button isIconOnly size="sm" color="primary" onPress={onOpen}>
        <EyeIcon className="size-4" />
      </Button>
      <Modal scrollBehavior="inside" size="5xl" isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Detail Pengangkutan</ModalHeader>
              <ModalBody>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="flex flex-col">
                    <span className="text-xs text-ink-400 uppercase">Jenis B3</span>
                    <span className="text-sm font-medium">
                      {data?.dataBahanB3?.casNumber} / {data?.dataBahanB3?.namaBahanKimia}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs text-ink-400 uppercase">Total Pengangkutan</span>
                    <span className="text-sm font-medium">{data?.jumlahB3} Kg</span>
                  </div>
                  <div className="col-span-2 flex flex-col gap-3">
                    {groupedData?.map((item, index) => (
                      <Card radius="sm">
                        <CardHeader>
                          <span className="text-xs text-ink-400 uppercase">Asal Muat dan Tujuan Bongkar</span>
                        </CardHeader>
                        <CardBody>
                          <div key={index}>
                            <div className="flex flex-col gap-1 mb-3">
                              <span className="text-sm">
                                Perusahaan Asal Muat: <strong>{item?.perusahaanAsalMuat?.namaPerusahaan}</strong>
                              </span>
                              <span className="text-sm">
                                Alamat: <strong>{item?.perusahaanAsalMuat?.alamat}</strong>
                              </span>
                            </div>
                            <ClientTablePagination header={headerTujuanBongkar} content={contentTujuanBongkar} data={item?.perusahaanTujuanBongkar} />
                          </div>
                        </CardBody>
                      </Card>
                    ))}
                  </div>
                </div>
              </ModalBody>
              <ModalFooter></ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
